import request from './request'

import axios from 'axios'

// 获取筛选面板数据
export function fetchFilterPanelData() {
  return request({
    url: `/cms/web/search/get_screening_criteria`,
    method: 'get'
  })
  // return axios('http://localhost:3000/filter_data.json')
}

// 获取视频列表
export function fetchHomeListData(data) {
  return request({
    url: `/cms/web/search/search_movie`,
    method: 'post',
    data
  })
}

/**
 * 获取详情
 */
export function fetchDetail(movieId = '', movieEpisodeId = '') {
  return request.get(`/cms/web/movie/get_movie_info?movieId=${movieId}&movieEpisodeId=${movieEpisodeId}`)
}

// 播放详情
export function fetchMoviePlayInfo(movieEpisodeId = '', movieId = '') {
  return request.get(`/cms/app/promotion/channel/get_movie_play_info?definition=GROOT_LD&movieEpisodeId=${movieEpisodeId}&movieId=${movieId}&channelType=MPC`)
}

/**
 * 获取5分钟播放链接
 */
export function fetchPlayLink(movieId, movieEpisodeId) {
  return request.get(`/cms/web/media/get_preview_play_info?movieId=${movieId}&movieEpisodeId=${movieEpisodeId}`)
}

/**
 * 搜索联想
 */
export function fetchSearchKeyWordLenovo(searchKeyWord) {
  return request.get(`/cms/web/search/search_key_word_lenovo?searchKeyWord=${searchKeyWord}`)
}

/**
 * 获取热搜榜单
 */
export function fetchSearchTop() {
  return request.get(`/cms/web/search/search_leaderboard`)
}

/**
 * 获取文章列表
 */
export function fetchArticles(data) {
  return request.post(`/cms/web/article_channel/query_article_list`, data)
}
/**
 * 获取文章列表前5条，排除当前条
 */
export function fetchArticlesTopFive(id) {
  return request.post(`/cms/web/article_channel/get_article_top?id=${id}`)
}
/**
 * 获取文章详情
 */
export function fetchArticle(id) {
  return request.post(`/cms/web/article_channel/get_article?id=${id}`)
}
/**
 * 获取文章详情
 */
export function fetchAlbumDetail(albumId, page = 0, size = 18) {
  return request.get(`/cms/web/album/detail?albumId=${albumId}&page=${page}&size=${size}`)
}
/**
 * 获取首页banner，片单
 */
export function fetchIndexData() {
  return request.get(`/cms/web/home/query?size=3`)
}
/**
 * PC-新内容-首页-API
 */
export function fetchIndexDataList(page, size) {
  return request.get(`/cms/web/home/query/section?size=${size}&page=${page}&styleType=SINGLE_ALBUM`)
}

/**
 * 搜索联想
 */
export function searchLenovo(data) {
  return request.post(`/loklok/cms/web/pc/search/searchLenovo`, data)
}
